import { d as dew } from './chunk-DtuTasat.js';

const exports = dew();
exports['Buffer']; exports['SlowBuffer']; exports['INSPECT_MAX_BYTES']; exports['kMaxLength'];

var Buffer = exports.Buffer;
var INSPECT_MAX_BYTES = exports.INSPECT_MAX_BYTES;
var kMaxLength = exports.kMaxLength;

export { Buffer, INSPECT_MAX_BYTES, exports as default, kMaxLength };
